import React from "react";
import { Block } from "baseui/block";
import { FormControl } from "baseui/form-control";
import { Select, SIZE as SSIZE } from "baseui/select";
import { Tag, VARIANT } from "baseui/tag";

function ModelRunItem({
  run,
  runAssets = [],
  onRemoveModelRun,
  onVtszAssetSelect,
  onMediaAssetSelect
}) {


  // Filter assets by type
  const getVtszAssets = (assets) => {
    return assets?.filter(asset => 
      asset.filename?.toLowerCase().endsWith('.vtksz') ||
      asset.filename?.toLowerCase().endsWith('.vtk') ||
      asset.filename?.toLowerCase().endsWith('.vtu') ||
      asset.filename?.toLowerCase().endsWith('.vtm')
    ) || [];
  };

  const getMediaAssets = (assets) => {
    const mediaExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.webp',
                            '.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv',
                            '.mp3', '.wav', '.ogg', '.aac', '.flac', '.m4a'];
    
    return assets?.filter(asset => {
      const filename = asset.filename?.toLowerCase() || '';
      return mediaExtensions.some(ext => filename.endsWith(ext));
    }) || [];
  };

  const vtszAssets = getVtszAssets(runAssets);
  const mediaAssets = getMediaAssets(runAssets);
  
  const vtszAssetOptions = vtszAssets.map(asset => ({
    id: asset.id,
    label: asset.filename,
    asset: asset
  }));
  
  const mediaAssetOptions = mediaAssets.map(asset => ({
    id: asset.id,
    label: asset.filename,
    asset: asset
  }));

  return (
    <Block
      padding="scale400"
      $style={{
        border: '1px solid #d0d0d0',
        backgroundColor: 'white',
        borderRadius: '8px'
      }}
    >
      {/* Model Run Header */}
      <Block
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="scale300"
        $style={{
          borderBottom: '1px solid #e0e0e0',
          paddingBottom: '8px'
        }}
      >
        <Block display="flex" flexDirection="column">
          <Block
            $style={{
              fontWeight: 'bold',
              fontSize: '14px',
              color: '#333'
            }}
          >
            {run.name}
          </Block>
          <Block
            $style={{
              fontSize: '11px',
              color: '#666',
              marginTop: '2px'
            }}
          >
            ID: {run.id} | Status: {run.status}
          </Block>
        </Block>
        <Tag
          variant={VARIANT.solid}
          onActionClick={() => onRemoveModelRun(run)}
          closeable
          size="small"
          $style={{
            backgroundColor: '#ff4444',
            color: 'white'
          }}
        >
          Remove
        </Tag>
      </Block>

      {/* VTSZ Assets Section */}
      <Block marginBottom="scale300">
        <FormControl
          label={() => "VTSZ/VTK Assets"}
          size="compact"
        >
          <Block>
            <Select
              size={SSIZE.compact}
              options={vtszAssetOptions}
              value={run.selectedVtszAssets || []}
              onChange={(params) => onVtszAssetSelect(run.id, params)}
              placeholder="Select VTSZ/VTK files..."
              clearable={false}
              multi
              closeOnSelect={false}
            />
          </Block>
        </FormControl>
      </Block>

      {/* Media Assets Section */}
      <Block>
        <FormControl
          label={() => "Media Assets (Images/Videos/Audio)"}
          size="compact"
        >
          <Block>
            <Select
              size={SSIZE.compact}
              options={mediaAssetOptions}
              value={run.selectedMediaAssets || []}
              onChange={(params) => onMediaAssetSelect(run.id, params)}
              placeholder="Select media files..."
              clearable={false}
              multi
              closeOnSelect={false}
            />
          </Block>
        </FormControl>
      </Block>
    </Block>
  );
}

export default ModelRunItem; 